import $ from "jquery";

$.fn.fileUploader = function(filesToUpload) {
  var fileIdCounter = 0;

  this.closest(".files").change(function(evt) {
    var output = [];

    for (var i = 0; i < evt.target.files.length; i++) {
      fileIdCounter++;
      var file = evt.target.files[i];
      var fileId = fileIdCounter;

      filesToUpload.push({
        id: fileId,
        file: file
      });

      var thumbnail =
        '<div class="o-list__thumbnail"><img src="images/document_default.png"></div>';
      var removeLink =
        '<a class="removeFile icon-trash" href="#" data-fileid="' +
        fileId +
        '"></a>';

      output.push("<li>", thumbnail, file.name, removeLink, "</li> ");
    }

    $(this)
      .children(".fileList")
      .append(output.join(""));

    //reset the input to null - nice little chrome bug!
    evt.target.value = null;
  });

  $(this).on("click", ".removeFile", function(e) {
    e.preventDefault();

    var fileId = $(this)
      .parent()
      .children("a")
      .data("fileid");

    // loop through the files array and check if the name of that file matches FileName
    // and get the index of the match
    for (var i = 0; i < filesToUpload.length; ++i) {
      if (filesToUpload[i].id === fileId) filesToUpload.splice(i, 1);
    }

    $(this)
      .parent()
      .remove();
  });

  this.clear = function() {
    // for (var i = 0; i < filesToUpload.length; ++i) {
    //   if (filesToUpload[i].id.indexOf(sectionIdentifier) >= 0)
    //     filesToUpload.splice(i, 1);
    // }

    $(this)
      .children(".fileList")
      .empty();
  };

  return this;
};

(function() {
  var filesToUpload = [];

  $("#files1").fileUploader(filesToUpload, "files1");
})();
